import getEnvVars from "../environment";
const {
  NIKU_CLIENT_APP_ID,
  CLIENT_API_KEY,
  NIKU_SELLER_APP_ID,
  SELLER_API_KEY,
  NIKU_DELIVERY_APP_ID,
  DELIVERY_API_KEY,
  NEW_MESSAGE_CHANNEL_DELIVERY,
  NEW_ORDER_CHANNEL_DELIVERY,
  NEW_MESSAGE_CHANNEL_CLIENT,
  NEW_ORDER_CHANNEL_CLIENT,
  NEW_MESSAGE_CHANNEL_SELLER,
  NEW_ORDER_CHANNEL_SELLER
} = getEnvVars();

const usePushNotifications = () => {
  const sendOneSignalNotifications = ({
    content = null,
    title = null,
    image = null,
    role = null,
    channel = null,
    ids = null,
  }) => {
    let APP_ID = getAppId(role);
    let API_KEY = getApiKey(role);
    let CHANNEL_ID = getChannel(channel, role);
    let SOUND_IOS = getIosSound(channel);

    const options = {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: API_KEY,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        include_external_user_ids: ids,
        headings: { en: title },
        contents: { en: image != null ? "(imagen)" : content },
        name: "CAMPAIGN TEST FOR NIKU",
        app_id: APP_ID,
        android_channel_id: CHANNEL_ID,
        small_icon: "notification_icon",
        ios_sound: SOUND_IOS,
        android_accent_color: "004990",
      }),
    };
    //console.log("🚀 ~ file: usePushNotifications.js ~ line 48 ~ usePushNotifications ~ options", options)

    fetch("https://onesignal.com/api/v1/notifications", options)
      .then((response) => response.json())
      .then((response) => console.log(response))
      .catch((err) => console.error(err));
  };

  const getAppId = (role) => {
    try {
      switch (role) {
        case "customers":
          return NIKU_CLIENT_APP_ID;
          break;
        case "seller":
          return NIKU_SELLER_APP_ID;
          break;
        case "deliveryman":
          return NIKU_DELIVERY_APP_ID;
          break;
        default:
          return null;
      }
    } catch (error) {
      console.log("ERROR GET APP ID PUSH NOTIFICATIONS --------> ", error);
      return null;
    }
  };

  const getApiKey = (role) => {
    try {
      switch (role) {
        case "customers":
          return CLIENT_API_KEY;
          break;
        case "seller":
          return SELLER_API_KEY;
          break;
        case "deliveryman":
          return DELIVERY_API_KEY;
          break;
        default:
          return null;
      }
    } catch (error) {
      console.log("ERROR GET API KEY PUSH NOTIFICATION -------> ", error);
      return null;
    }
  };

  const getChannel = (channel, role) => {
    try {
      if (channel === "new-message" && role === "customers") {
        return NEW_MESSAGE_CHANNEL_CLIENT;
      } else if (channel === "new-order" && role === "deliveryman") {
        return NEW_ORDER_CHANNEL_DELIVERY;
      } else if (channel === "new-message" && role === "deliveryman") {
        return NEW_MESSAGE_CHANNEL_DELIVERY;
      } else if (channel === "new-order" && role === "customers") {
        return NEW_ORDER_CHANNEL_CLIENT;
      } else if (channel === "new-message" && role === "seller") {
        return NEW_MESSAGE_CHANNEL_SELLER;
      } else if (channel === "new-order" && role === "seller") {
        return NEW_ORDER_CHANNEL_SELLER;
      } else {
        return null;
      }
    } catch (error) {
      console.log("ERROR GET CHANNEL PUSH NOTIFICATIONS -----> ", error);
      return null;
    }
  };

  const getIosSound = (channel) => {
    try {
      switch (channel) {
        case "new-order":
          return "negocio.wav";
        default:
          return "";
      }
    } catch (error) {
      console.log("ERROR GET IOS SOUND PUSH NOTIFICATION ------> ", error);
      return "";
    }
  };

  return {
    sendOneSignalNotifications,
  };
};

export default usePushNotifications;
